export default "__VITE_ASSET__CemUTHbr__"